import './bootstrap';

window.$= window.jQuery= require('jquery')


import {createApp} from 'vue'

import VueFormulate from '@formkit/vue'
import { plugin, defaultConfig } from '@formkit/vue'
import '@formkit/themes/genesis'


import ListaFichEleccionesComponent from './vue/components/ListaFichEleccionesComponent.vue'
import  GrupoComponent from './vue/components/GrupoComponent.vue'
import ListaFichDocComponent from './vue/components/ListaFichDocComponent.vue'
import TerritorioSectorUsuario1Component from './vue/components/TerritorioSectorUsuario1Component.vue'
import  CalendarComponent from './vue/components/CalendarComponent.vue'
import  CalculadoraComponent from './vue/components/CalculadoraComponent.vue'
import  UsuarioToGrupoComponent from './vue/components/UsuarioToGrupoComponent.vue'
import RedesSocialesFormComponent from './vue/components/RedesSocialesFormComponent.vue'






const app=createApp({})

app.component('lista-fich-elecciones-component',ListaFichEleccionesComponent)
app.component('lista-fich-doc-component',ListaFichDocComponent)
app.component('calendar-component',CalendarComponent)
app.component('grupo-component',GrupoComponent)
app.component('calculadora-component',CalculadoraComponent)
app.component('territorio-sector-usuario1-component',TerritorioSectorUsuario1Component)
app.component('usuario-to-grupo-component',UsuarioToGrupoComponent)
app.component('redes-sociales-form-component', RedesSocialesFormComponent)



app.use(plugin, defaultConfig).mount('#app')
//app.mount('#app')
